import { IconWrapper, type IconProps } from '../SlideTypeIcon';

export const PowerpointIcon = ({ size = 32 }: IconProps) => (
  <IconWrapper size={size}>
    <path
      d="M17.4902 6.37158C14.9455 6.379 12.5072 7.39315 10.7079 9.19249C8.90853 10.9918 7.89438 13.4301 7.88696 15.9748L20.0535 18.5382L17.4902 6.37158Z"
      fill="#ED6C47"
    />
    <path
      d="M17.4902 6.37158C20.0349 6.379 22.4732 7.39315 24.2725 9.19249C26.0719 10.9918 27.086 13.4301 27.0934 15.9748L22.2918 19.2385L17.4902 15.9748V6.37158Z"
      fill="#FF8F6B"
    />
    <path
      d="M17.4902 25.5783C20.0348 25.5709 22.4731 24.5567 24.2725 22.7574C26.0718 20.9581 27.086 18.5197 27.0934 15.9751H7.88696C7.89438 18.5197 8.90853 20.9581 10.7079 22.7574C12.5072 24.5567 14.9455 25.5709 17.4902 25.5783Z"
      fill="#D35230"
    />
    <path
      opacity="0.1"
      d="M16.5752 9.80176H10.1547C8.58673 11.6492 7.78016 14.024 7.89863 16.4443C8.0171 18.8646 9.05173 21.1492 10.7927 22.8347H16.5752C16.8176 22.8341 17.0499 22.7377 17.2214 22.5663C17.3928 22.395 17.4895 22.1627 17.4902 21.9203V10.7161C17.4895 10.4737 17.3928 10.2415 17.2214 10.0701C17.0499 9.89879 16.8176 9.8023 16.5752 9.80176Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M15.889 10.4873H9.62909C8.21514 12.4935 7.62894 14.9676 7.99241 17.3949C8.35588 19.8223 9.64103 22.0162 11.5806 23.5202H15.8897C16.132 23.5195 16.3641 23.4229 16.5354 23.2516C16.7068 23.0803 16.8033 22.8482 16.8041 22.6059V11.4017C16.8033 11.1593 16.7067 10.927 16.5352 10.7557C16.3637 10.5843 16.1314 10.4878 15.889 10.4873Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M15.8889 10.4873H9.629C8.41108 12.2141 7.80175 14.2968 7.89687 16.4077C7.99199 18.5187 8.78615 20.5381 10.1544 22.1483H15.8896C16.1319 22.1476 16.364 22.0511 16.5354 21.8797C16.7067 21.7084 16.8033 21.4763 16.804 21.234V11.4017C16.8033 11.1593 16.7066 10.927 16.5351 10.7557C16.3637 10.5843 16.1313 10.4878 15.8889 10.4873Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M15.203 10.4873H9.629C8.41108 12.2141 7.80175 14.2968 7.89687 16.4077C7.99199 18.5187 8.78615 20.5381 10.1544 22.1483H15.2037C15.4459 22.1476 15.6781 22.0511 15.8494 21.8797C16.0207 21.7084 16.1173 21.4763 16.118 21.234V11.4017C16.1173 11.1593 16.0206 10.927 15.8492 10.7557C15.6777 10.5843 15.4454 10.4878 15.203 10.4873Z"
      fill="black"
    />
    <path
      d="M6.05767 10.4873H15.204C15.4465 10.4873 15.6791 10.5836 15.8506 10.7551C16.0221 10.9266 16.1184 11.1592 16.1184 11.4017V20.548C16.1184 20.7905 16.0221 21.0231 15.8506 21.1946C15.6791 21.3661 15.4465 21.4624 15.204 21.4624H6.05767C5.81517 21.4624 5.5826 21.3661 5.41112 21.1946C5.23964 21.0231 5.14331 20.7905 5.14331 20.548V11.4017C5.14331 11.1592 5.23964 10.9266 5.41112 10.7551C5.5826 10.5836 5.81517 10.4873 6.05767 10.4873Z"
      fill="#C43E1C"
    />
    <path
      d="M10.6287 12.545C11.3041 12.4996 11.9738 12.6952 12.5185 13.0972C12.7419 13.2966 12.917 13.5441 13.0306 13.8211C13.1442 14.0981 13.1933 14.3974 13.1742 14.6962C13.1817 15.0841 13.0683 15.4648 12.8498 15.7854C12.6273 16.1398 12.3072 16.4223 11.9279 16.599C11.4942 16.8003 11.0203 16.8998 10.5423 16.8898H9.2321V19.4045H7.88696V12.545H10.6287ZM9.23141 15.7573H10.3886C10.7555 15.7843 11.1196 15.6759 11.412 15.4528C11.5282 15.378 11.6218 15.273 11.6828 15.1489C11.7437 15.0249 11.7696 14.8866 11.7577 14.749C11.7577 13.9903 11.3158 13.611 10.4318 13.611H9.23141V15.7573Z"
      fill="#F9F7F7"
    />
  </IconWrapper>
);
